import { getClass, createProps } from "../../utils";
import React from "react";
var rowKeys = ["start", "center", "end", "top", "middle", "bottom", "around", "between"];

var getRowClassNames = function getRowClassNames(props) {
  var modificators = [props.className, getClass("row")];

  for (var i = 0; i < rowKeys.length; ++i) {
    var key = rowKeys[i];
    var value = props[key];

    if (value) {
      modificators.push(getClass("".concat(key, "-").concat(value)));
    }
  }

  if (props.reverse) {
    modificators.push(getClass("reverse"));
  }

  return modificators.filter(function (cn) {
    return cn;
  });
};

export var getRowProps = function getRowProps(props) {
  return createProps(props, getRowClassNames(props));
};
export default function Row(props) {
  return /*#__PURE__*/React.createElement(props.as || "div", getRowProps(props));
}